export default __webpack_public_path__ + "static/media/Grab.e6e099c1.svg";